module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_111_12.2f1e7f0e.pdf";